import {
  Avatar,
  Box,
  IconButton,
  Modal,
  Stack,
  Typography,
} from "@mui/material";
import { useFormatter } from "../../../utils/useFormatter";
import { useSessionContext } from "../../../contexts/SessionContext";
import { useNavigate } from "react-router-dom";
import { FormButtonGroup } from "../../../components/form";
import { Close } from "@mui/icons-material";

/**
 * Modal de boas-vindas para criar a primeira agenda.
 * A validação de contrato ativo foi removida da plataforma (contrato passa a ser sempre válido na criação).
 */
export function ModalSchedule({ handleClose, open }: any) {
  const { user, loading } = useSessionContext();

  const navigate = useNavigate();

  return (
    <Modal
      open={open}
      onClose={handleClose}
      // Garante que o aviso fique acima de drawers/layout (evita modal “invisível” por empilhamento).
      sx={{ zIndex: (theme) => theme.zIndex.modal + 10 }}
    >
      <Box
        sx={(theme) => ({
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "50%",
          height: "75vh",
          background: `linear-gradient(${theme.palette.primary700.main} 20%, ${theme.palette.neutral0.main} 38%)`,
          borderRadius: "10px",
          boxShadow: 24,
          p: 4,
        })}
      >
        <Stack
          direction="column"
          justifyContent="space-around"
          alignItems="center"
          height="90%"
        >
          <IconButton
            onClick={handleClose}
            sx={{ position: "absolute", right: 5, top: 5 }}
          >
            <Close />
          </IconButton>
          <Stack alignItems="center" spacing={3}>
            <Avatar
              sx={{
                width: 90,
                height: 90,
                backgroundColor: "primary100.main",
                color: "primary900.main",
              }}
            >
              <Typography variant="h3" fontWeight={600}>
                {user?.name?.slice(0, 1)}
              </Typography>
            </Avatar>

            <Typography variant="h5" fontWeight={600}>
              Bem vindo ao Fluxmed,{" "}
              {useFormatter.formatNameDisplay(user?.givenName)}!
            </Typography>
          </Stack>
          <Stack alignItems="center" spacing={3} width="80%">
            <Typography variant="h5" fontWeight={600}>
              Crie sua primeira agenda e inicie sua jornada.
            </Typography>
          </Stack>
          <Stack
            width="80%"
            direction="row"
            alignItems="center"
            justifyContent="center"
            spacing={3}
          >
            <FormButtonGroup
              onGoBackButtonClick={() => {
                localStorage.setItem("scheduleCreated", "true");
                handleClose();
              }}
              onNextButtonClick={() => navigate("/newschedule")}
              goBackButtonText="Fechar"
              nextButtonText="Criar Agenda"
              loading={loading}
            />
          </Stack>
        </Stack>
      </Box>
    </Modal>
  );
}
